import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import {LeaveApplication} from "../../../../shared/interface/employee";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {
  DictService,
  LEAVE_APPLICATION_STATUS,
  LEAVE_APPLICATION_STATUS_ACCEPTED,
  LEAVE_APPLICATION_STATUS_CANCEL, LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE,
  LEAVE_APPLICATION_STATUS_REJECTED, LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE,
  RECEIVABLES_IMPORT_ROW_STATUS,
  RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION
} from "../../../../shared/services/dict.service";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {LeaveApplicationService} from "../../../../shared/services/leave-application.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";
import {InvoiceDocument} from "../../../../shared/interface/invoice-document";
import {
  OfwcaChangeAccountNumberDialogComponent
} from "../../../ofwcas/ofwca-change-account-number-dialog/ofwca-change-account-number-dialog.component";
import {LeaveApplicationAddFileComponent} from "../leave-application-add-file/leave-application-add-file.component";

@Component({
  selector: 'app-leave-application-details-view',
  templateUrl: './leave-application-details-view.component.html',
  styleUrls: ['./leave-application-details-view.component.scss']
})
export class LeaveApplicationDetailsViewComponent implements OnInit, OnDestroy, OnChanges  {
  @Input() leaveApplication: LeaveApplication;
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() modifyClicked = new EventEmitter<any>();
  userPermissions: ReplaySubject<UserPermissions>;

   readonly RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION = RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION;
   readonly LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE = LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE;
   readonly LEAVE_APPLICATION_STATUS_ACCEPTED = LEAVE_APPLICATION_STATUS_ACCEPTED;
   readonly LEAVE_APPLICATION_STATUS_REJECTED = LEAVE_APPLICATION_STATUS_REJECTED;
   readonly LEAVE_APPLICATION_STATUS_CANCEL = LEAVE_APPLICATION_STATUS_CANCEL;
   readonly LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE = LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE;




  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private dictService: DictService,
    private leaveApplicationService: LeaveApplicationService,
    private snack: MatSnackBar,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  accept(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zaakceptować wniosek urlopowy?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(LEAVE_APPLICATION_STATUS_ACCEPTED, LEAVE_APPLICATION_STATUS)
          .subscribe((dictId: number) => {
            this.leaveApplicationService.statusUpdate(this.leaveApplication.uuid, dictId)
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              }, (httpError: HttpErrorResponse) => {
                this.snack.open('Podczas aktualizacji obiektu pracownik wystąpił błąd', httpError.status.toString(), {
                  duration: 2000,
                });

                if (httpError.status === 400) {
                  // this.formErrors = httpError.error.error.list;
                  // this.formHelper.setBackendErrorState(this.employeeForm, this.formErrors);
                  if ('status' in httpError.error.error.list) {
                    const nestedDialogRef = this.dialog.open(ConfirmDialogComponent, {
                        width: '500px',
                        data: {text: 'Wniosek urlopowy przekracza kwartalny limit wykorzystania urlopu. Czy chesz zakceptować mimo to?'}
                    });
                    nestedDialogRef.afterClosed().subscribe(nestedResult => {
                      if (nestedResult) {
                        this.leaveApplicationService.statusUpdate(this.leaveApplication.uuid, dictId, true)
                          .subscribe(() => {
                            this.changed.emit();
                            this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
                          }, (nestedHttpError: HttpErrorResponse) => {
                            this.snack.open('Podczas aktualizacji obiektu pracownik wystąpił błąd', nestedHttpError.status.toString(), {
                              duration: 2000,
                            });

                            if (nestedHttpError.status === 400) {
                              this.snack.open(nestedHttpError.error.error.text, nestedHttpError.status.toString(), {
                                duration: 4000,
                              });
                            }
                          });
                      }
                    });
                  } else {
                    this.snack.open(httpError.error.error.text, httpError.status.toString(), {
                      duration: 4000,
                    });
                  }
                }
              });
          });
      }
    });
  }
  cancel(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz anulować wniosek urlopowy?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(LEAVE_APPLICATION_STATUS_CANCEL, LEAVE_APPLICATION_STATUS)
          .subscribe((dictId: number) => {
            this.leaveApplicationService.statusUpdate(this.leaveApplication.uuid, dictId)
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              }, (error: HttpErrorResponse) => {
                this.snack.open('Podczas aktualizacji obiektu pracownik wystąpił błąd', error.status.toString(), {
                  duration: 2000,
                });

                if (error.status === 400) {
                  // this.formErrors = error.error.error.list;
                  // this.formHelper.setBackendErrorState(this.employeeForm, this.formErrors);
                  this.snack.open(error.error.error.text, error.status.toString(), {
                    duration: 4000,
                  });
                }
              });
          });
      }
    });
  }

  reject(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz odrzucić wniosek urlopowy?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(LEAVE_APPLICATION_STATUS_REJECTED, LEAVE_APPLICATION_STATUS)
          .subscribe((dictId: number) => {
            this.leaveApplicationService.statusUpdate(this.leaveApplication.uuid, dictId)
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              }, (error: HttpErrorResponse) => {
                this.snack.open('Podczas aktualizacji obiektu pracownik wystąpił błąd', error.status.toString(), {
                  duration: 2000,
                });

                if (error.status === 400) {
                  // this.formErrors = error.error.error.list;
                  // this.formHelper.setBackendErrorState(this.employeeForm, this.formErrors);
                  this.snack.open(error.error.error.text, error.status.toString(), {
                    duration: 4000,
                  });
                }
              });
          });
      }
    });
  }

  forAcceptance(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz cofnąć wniosek urlopowy do akceptacji?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE, LEAVE_APPLICATION_STATUS)
          .subscribe((dictId: number) => {
            this.leaveApplicationService.statusUpdate(this.leaveApplication.uuid, dictId)
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              }, (error: HttpErrorResponse) => {
                this.snack.open('Podczas aktualizacji obiektu pracownik wystąpił błąd', error.status.toString(), {
                  duration: 2000,
                });

                if (error.status === 400) {
                  // this.formErrors = error.error.error.list;
                  // this.formHelper.setBackendErrorState(this.employeeForm, this.formErrors);
                  this.snack.open(error.error.error.text, error.status.toString(), {
                    duration: 4000,
                  });
                }
              });
          });
      }
    });
  }

  formatMinutesToHours(minutes: number): string {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h} h ${m.toString().padStart(2, '0')} min`;
  }
  downloadDocument(): void {
    this.leaveApplicationService.downloadDocument(
      this.leaveApplication.uuid
    );
  }

  addFile(): void {
    const dialogRef = this.dialog.open(LeaveApplicationAddFileComponent, {
      width: '700px',
      data: {leaveApplication: this.leaveApplication},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.changed.emit();
    });
  }

  modify(): void {
    this.modifyClicked.emit();
  }
}
